var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('MentionBox',{attrs:{"type":"variable","items":_vm.items},on:{"mentionSelect":_vm.handleVariableClick}}):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }